/**
 * opora-ai-payload.js — enrich worker API bodies with profile + pipeline context
 */
(function (global) {
  'use strict';

  function toolSlug() {
    var m = document.querySelector('meta[name="opora:tool-slug"]');
    return m ? m.content : '';
  }

  function enrich(body) {
    var base = body && typeof body === 'object' ? Object.assign({}, body) : {};
    if (global.OporaProfile && typeof global.OporaProfile.get === 'function') {
      base.profile = base.profile || global.OporaProfile.get();
      base.lang = base.lang || global.OporaProfile.getLang();
    }
    if (global.OporaSpine && typeof global.OporaSpine.getThreadContext === 'function') {
      base.pipeline_context = base.pipeline_context || global.OporaSpine.getThreadContext();
    }
    if (global.OporaAccountFile && typeof global.OporaAccountFile.getContext === 'function') {
      base.account_context = global.OporaAccountFile.getContext();
    }
    if (global.OporaGeo && typeof global.OporaGeo.enrichBody === 'function') {
      base = global.OporaGeo.enrichBody(base, base.question || '');
    }
    if (!base.brand_voice) {
      base.brand_voice = 'operator_direct';
    }
    if (!base.system_instruction && !base.system_prompt) {
      base.system_instruction = 'Voice: operator_direct — short, practical, confident. Never say as an AI, delve, or game-changer.';
    }
    if (global.OporaStructured && typeof global.OporaStructured.enrich === 'function') {
      base = global.OporaStructured.enrich(base);
    }
    if (!base.surface) base.surface = toolSlug() || global.location.pathname;
    return base;
  }

  function patchFetchApi() {
    var edge = global.OporaEdge;
    if (!edge || edge.__payloadPatched || typeof edge.fetchApi !== 'function') return;

    var orig = edge.fetchApi.bind(edge);
    edge.fetchApi = function (path, opts) {
      opts = opts || {};
      if (opts.body && typeof opts.body === 'string' && path.indexOf('/api/') !== -1) {
        try {
          var parsed = JSON.parse(opts.body);
          opts.body = JSON.stringify(enrich(parsed));
        } catch (e) {}
      }
      return orig(path, opts);
    };
    edge.__payloadPatched = true;
  }

  function init() {
    patchFetchApi();
    if (!global.OporaEdge) {
      var tries = 0;
      var t = setInterval(function () {
        patchFetchApi();
        if ((global.OporaEdge && global.OporaEdge.__payloadPatched) || ++tries > 50) clearInterval(t);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  global.OporaAiPayload = { enrich: enrich };

})(window);
